import { Row, Text } from 'native-base'

import { Icon } from './Icon'
import { Spacer, PressableGesture } from './atoms'

export const Chip = ({ text, onPress }: { text: string; onPress: () => void }) => {
  return (
    <PressableGesture onPress={onPress}>
      <Row rounded="lg" alignItems="center" bg="offBlue" px="2" py="2">
        <Text color="actionBlue" fontWeight="600">
          {text}
        </Text>
        <Spacer x="1" />
        <Icon name="close-line" size={15} />
      </Row>
    </PressableGesture>
  )
}
